var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.294 1.707A1 1 0 0 1 1.707.294L8 6.587 14.293.294a1 1 0 0 1 1.413 1.413L9.413 8l6.293 6.293a1 1 0 0 1-1.413 1.413L8 9.413l-6.293 6.293a1 1 0 0 1-1.413-1.413L6.587 8z"
  })));
};
export default SvgCloseIcon;